const validationMessages = Object.freeze({
    FULLNAME: "Full Name is required.",
    MOBNO: "Mobile Number is required.",
    EMAIL: "Valid Email is required.",
    NOOFCHILDEREN: "Number of children must be provided.",
    TYPE: "User type must be selected.",
    GRADE: "Grade is required.",
    MEDIUM: "Medium is required.",
    SCHOOLNAME: "School name is required.",
    MOTHERTONGUE: "Mother tongue is required.",
    PARENTEDUCATION: "Parent's education level is required.",
    GENDER: "Gender must be selected.",
    CREATEDBY: "Parent must be selected.",
    PARENTINCOME: "Parent's income is required.",
    DOB: "Date of Birth is required.",
    USERID: "User ID is required.",
    ROLE: "Role must be selected.",
    PASSWORD: "Password is required.",
    CONFIRM_PASSWORD: "Confirm Password is required.",
    PIN: "PIN is required.",
    VERIFICATIONCODE: "Verification code is required.",
    ADDRESS: "Address is required.",
    CITY: "City is required.",
    STATE: "State is required.",
    COUNTRY: "Country is required.",
    PINCODE: "Pincode is required.",
    MOBNOLENGTH: "Mobile number must be 6 to 15 digits.",
    EMAILFORMAT: "Please enter a valid email format.",
    LANGUAGE: "At least one language must be selected.",
    COUNTRYSELECT: "Please select a country.",
    NAME: "Name is required.",
    DESC: "Description is required.",
    SKILLINDICATORID: "Skill Indicator ID is required.",
    NAME_REQUIRED: "Name is required in all languages",
    DESC_REQUIRED: "Description is required in all languages",
    NOTIFICATION_TYPE: "Notification type is required.",
    NOTIFICATION_TITLE: "Notification title is required.",
    NOTIFICATION_MESSAGE: "Notification message is required.",
    NOTIFICATION_IMAGE: "Notification image must be a valid file type (PNG or JPEG).",
    SHORT_NAME: "Short Name is required",
    PASSWORD_MIN_LENGTH: "Password must be at least 4 characters.",
    CONFIRM_PASSWORD_MIN_LENGTH: "Confirm Password must be at least 4 characters.",
    PASSWORDS_DO_NOT_MATCH: "New password and confirm password do not match.",
    NEW_PASSWORD_SAME_AS_CURRENT: "New password must be different from current password.",
    MESSAGE_REQUIRED: "Message cannot be empty.",
    MESSAGE_MIN_LENGTH: "Message must be at least 3 characters.",
    INTRODUCTION_NAME_REQUIRED: "Introduction name is required in all languages.",
    INTRODUCTION_CONTENT_REQUIRED: "Introduction content is required in all languages.",
    INTRODUCTION_IMAGE_REQUIRED: "Introduction image is required.",
    SKILL_NAME_REQUIRED: "Skill Name is required",
    SERVICE_NAME_REQUIRED: "Service name is required in all languages.",
    SERVICE_CONTENT_REQUIRED: "Service content is required in all languages.",
    SERVICE_IMAGE_REQUIRED: "Service image is required for each language.",
    LANGUAGE_SETTING_NAME:"Name is Required",
    LANGUAGE_SETTING_KEY:"Key is Required"

});

module.exports = { validationMessages };
